/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function DocumentIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="78.5"
        cy="78.5"
        r="77.5"
        fill={mainColor}
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M98.6116 67.9095C100.502 65.6336 103.279 64.3221 106.25 64.3221V46.769C106.25 39.748 100.502 34 93.4428 34H62.7351C60.8825 34 59.108 34.3857 57.4108 35.1957C56.1375 35.7744 54.9423 36.6235 53.862 37.6261L39.6647 51.6684C38.8933 52.4784 37.8517 53.7904 37.2734 55.1405C36.4248 56.761 36 58.6126 36 60.6187V104.867C36 111.927 41.7094 117.637 48.7308 117.637H87.6175V105.176C84.145 104.79 81.1744 102.707 79.6703 99.4663C78.0117 95.9556 78.5514 91.8666 81.0595 88.8575L98.6116 67.9095ZM62.85 91.5196H56.0602C53.9006 91.5196 52.2025 89.8219 52.2025 87.6618C52.2025 85.5398 53.9006 83.804 56.0602 83.804H62.85C64.9719 83.804 66.7077 85.5398 66.7077 87.6618C66.7077 89.8219 64.9719 91.5196 62.85 91.5196ZM78.5128 74.6992H56.0602C53.9006 74.6992 52.2025 72.9634 52.2025 70.8415C52.2025 68.72 53.9006 66.9837 56.0602 66.9837H78.5128C80.6733 66.9837 82.3705 68.72 82.3705 70.8415C82.3705 72.9634 80.6733 74.6992 78.5128 74.6992Z"
        fill={secondaryColor}
      />
      <path
        d="M97.5733 122.367H114.928C116.165 122.367 117.169 121.364 117.169 120.126V99.7498C117.169 98.5118 118.172 97.5082 119.411 97.5082H123.812C125.714 97.5082 126.752 95.2869 125.531 93.828L107.969 72.849C107.074 71.7786 105.427 71.7786 104.532 72.849L86.97 93.828C85.7485 95.2869 86.7864 97.5082 88.6889 97.5082H93.0901C94.3286 97.5082 95.3317 98.5118 95.3317 99.7498V120.126C95.3317 121.364 96.3347 122.367 97.5733 122.367Z"
        fill={secondaryColor}
      />
    </svg>
  );
}
DocumentIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
DocumentIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(DocumentIcon);
memoized.displayName = 'DocumentIcon';
export default memoized;
